import styled from "@emotion/styled";
import { Box } from "@mui/material";
import MKButton from "components/MKButton";

export const StyledTherapyOptionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.up("md")]: {
    rowGap: ".5rem",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const StyledTherapyOptionButton = styled(MKButton)(({ theme }) => ({
  borderRadius: "16px",
  padding: "6px 8px",
  alignItems: "center",
  fontSize: "10px !important",
  [theme.breakpoints.up("md")]: {
    padding: "8px 12px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "12px !important",
  },
}));
